export default __webpack_public_path__ + "static/media/pi-ico.65faf897.svg";